import { render, staticRenderFns } from "./CApprBtn.vue?vue&type=template&id=5f700878"
import script from "./CApprBtn.vue?vue&type=script&lang=js"
export * from "./CApprBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f700878')) {
      api.createRecord('5f700878', component.options)
    } else {
      api.reload('5f700878', component.options)
    }
    module.hot.accept("./CApprBtn.vue?vue&type=template&id=5f700878", function () {
      api.rerender('5f700878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CApprBtn.vue"
export default component.exports